import React from "react";

export default function WebsiteMaintenance() {
  return (
    <div className="container" style={{ paddingTop: 10 }}>
      <h1 className="center-content">
        <span>เว็บไซต์ ปิดปรับปรุง</span>
      </h1>
      <p className="center-content">ขออภัยในความไม่สะดวก</p>
      <h4 className="center-content">
        <span>ช่วงเวลา ปิดปรับปรุง</span>
      </h4>
      <p className="center-content">วันที่ 25/01/2565 07.00 น.</p>
      <p className="center-content">ถึง</p>
      <h2 className="center-content">
        <span>วันที่ 25/01/2565 18.00 น.</span>
      </h2>
    </div>
  );
}
